import i18n from '@/config/i18n'
import type { RouteLocationNormalizedLoaded } from 'vue-router'

export function resolveRouteTitle(route: RouteLocationNormalizedLoaded): string {
  const name = route.name != null ? String(route.name) : ''
  if (name) {
    const key = `meta.${name}`
    if (i18n.global.te(key)) {
      return i18n.global.t(key)
    }
  }
  const fallback = route.meta.title
  if (typeof fallback === 'string') {
    return fallback
  }
  return ''
}

export function applyDocumentTitle(route: RouteLocationNormalizedLoaded): void {
  const pageTitle = resolveRouteTitle(route)
  const appTitle = import.meta.env.VITE_APP_TITLE
  document.title = pageTitle ? `${pageTitle} - ${appTitle}` : appTitle
}
